import dynamic from 'next/dynamic';

const InstagramReels = dynamic(() => import('../../components/InstagramReels/InstagramReels').then((mod) => mod.InstagramReels));

const Testimonials = dynamic(() =>
  import('../../components/Testimonials').then((mod) => mod.Testimonials)
);
const ListDescriptionSection = dynamic(() =>
  import('../../components/ListDescriptionSection').then(
    (mod) => mod.ListDescriptionSection
  )
);
const Reels = dynamic(() => import('../../components/Reels').then((mod) => mod.Reels));
const BlogHeroPage = dynamic(() =>
  import('../../../BlogWidget').then((mod) => mod.BlogHeroPage)
);
const LogoSliderRenderer = dynamic(() => import('../../components/LogoSliderComponent'));
const GalleryWidget = dynamic(() => import('../../components/GalleryWidget'));
const ProductCardRenderer = dynamic(() => import('../../components/ProductCardRenderer'));
const MultiColumnRenderer = dynamic(() => import('../../components/MultiColumnRenderer'));
const BlogWidgetRenderer = dynamic(
  () => import('../../../BlogWidget/BlogWidgetRenderer')
);
const AuthorImageList = dynamic(
  () => import('../../components/Testimonials/Components/AuthorImageList')
);
const CarouselIndicator = dynamic(
  () => import('../../../CardFrameCollection/components/CarouselIndicator')
);
const ViewMoreButton = dynamic(() => import('../../components/ViewMoreButton'));
export default function getElementsToMap({
  contentTypeConditions,
  showAuthorImageList,
  viewAllItemsConfig,
  props,
}) {
  const elementsToMap = {
    header: [],
    body: [],
    footer: [],
  };
  // Push Header elements
  elementsToMap.header.push({ Component: ListDescriptionSection, props: {} });
  if (props?.isBlogListingPage) {
    elementsToMap.header.push({ Component: BlogHeroPage, props: {} });
  }

  if (contentTypeConditions.testimonials || contentTypeConditions.productTestimonial) {
    elementsToMap.body.push({ Component: Testimonials, props: {} });
  } else if (contentTypeConditions.featuredReels) {
    elementsToMap.body.push({ Component: Reels, props: {} });
  } else if (contentTypeConditions.logoSlider) {
    elementsToMap.body.push({ Component: LogoSliderRenderer, props: {} });
  } else if (contentTypeConditions.blogs) {
    elementsToMap.body.push({ Component: BlogWidgetRenderer, props: {} });
  } else if (contentTypeConditions.gallery) {
    elementsToMap.body.push({ Component: GalleryWidget, props: {} });
  } else if (contentTypeConditions.multiColumn) {
    elementsToMap.body.push({ Component: MultiColumnRenderer, props: {} });
  } else if (contentTypeConditions.instagram) {
    elementsToMap.body.push({ Component: InstagramReels, props: {} });
  } else {
    elementsToMap.body.push({ Component: ProductCardRenderer, props: {} });
  }

  // Push footer elements
  if (viewAllItemsConfig.forCarousel) {
    elementsToMap.footer.push({ Component: ViewMoreButton, props: {} });
  }
  if (
    (contentTypeConditions.testimonials || contentTypeConditions.productTestimonial) &&
    showAuthorImageList
  ) {
    elementsToMap.footer.push({ Component: AuthorImageList, props: {} });
  }
  elementsToMap.footer.push({ Component: CarouselIndicator, props: {} });
  if (!viewAllItemsConfig.forCarousel) {
    elementsToMap.footer.push({ Component: ViewMoreButton, props: {} });
  }

  return { elementsToMap };
}
